import React, {useEffect} from "react";
import PropTypes from 'prop-types';

import { getObjectByPath } from "../../../utils";
import { FieldTable } from "../../../components/FieldTable/FieldTable";
import { variableCurrencyValue } from "../../../components/field-table";
import { FieldTableColumnProps } from "../../../components/FieldTable/FieldTableTypes";
import {ExperientialTypeSelect} from "../../../components/MaterialSelects/ExperientialTypeSelect";
import {useOutletContext} from "react-router-dom";
import {CampaignOutletContextValue} from "../form";
import { RegionSelectGrouped } from "../../../components/MaterialSelects/RegionSelectGrouped";
import { Experiential } from "../../../generated/graphql";


const summaries = {
  footer: (old, newRow) => { return !newRow; }
}

function newRow() {
  return {
    campaignComponent: {
      region: null,
      regionType: null,
      unit_value_local: '',
      qty: ''
    },
    experientialType: null,
    start_date: null,
    end_date: null,
    name: ''
  };
}

const ExperientialPane = () => {
  const { setValue, values, errors, loading, readOnly,setTab,isReadOnly } = useOutletContext<CampaignOutletContextValue>();
  const columns: FieldTableColumnProps<Experiential>[] = [
    {
      header: 'Region',
      accessor: 'campaignComponent.region',
      sort: 'campaignComponent.region.name',
      dataType:'select',
      width:'minmax(14rem, max-content)',
      options: {
          renderViewer:({field,row})=>{
              const rt = getObjectByPath(row, 'campaignComponent.regionType');
              return rt?.name ? rt.name + ' / ' + field?.value?.name : '';
          },
          renderEditor: function rtEdit({field}) {
              const changeRt = (evt) => {
                  const name = evt.target.name;
                  field.onChange({target: {name: name, value: evt?.target?.value}});
                  field.onChange({target: {name: name + 'Type', value: evt?.target?.value?.regionType}});
              }
              return <RegionSelectGrouped isCompositeChange={true} {...field} allowBlank={true} onChange={changeRt}
                                          autoFocus={true}/>;
          }
      }
    } /* {
      header: 'Region',
      accessor: 'campaignComponent.region',
      sort: 'campaignComponent.region.name',
      dataType:'select',
      options: {
        label:'name',
        renderEditor: ({ field, row }) => {
          const rt = getObjectByPath(row, 'campaignComponent.regionType');
          return <RegionSelect regionType={rt ? rt.id : null} {...field} autoFocus={true} />;
        }
      }
    }*/, {
      header: 'Type',
      accessor: 'experientialType',
      sort: 'experientialType.name',
      dataType:'select',
      options:{
        label:'name',
        renderEditor: ({ field }) => <ExperientialTypeSelect {...field} autoFocus={true} />
      }
    }, {
      header: 'Start Date',
      accessor: 'start_date',
      dataType:'date',
    },
    {
      header: 'End Date',
      accessor: 'end_date',
      dataType:'date',
    }, {
      header: 'Unit Price',
      accessor: 'campaignComponent.unit_value_local',
      dataType:'currency',
      readOnly:()=>{
        return isReadOnly(true);
      },
      options: {
        currency: {
          accessor: 'campaignComponent.currency',
          allowContextCurrency:true
        }
      },
      summaries: {
        footer: () => {
          return <b style={{display:'flex',alignItems:'center'}}>Total</b>
        }
      }
    }, {
      header: 'Qty',
      accessor: 'campaignComponent.qty',
      dataType:'number',
      readOnly:()=>{return isReadOnly(true)},
      summaries: {
        footer: ({ rows }) => {
          return rows.reduce((total,current)=> { return total+(parseInt(current.campaignComponent?.qty)||0); },0)
        }
      }
    }, {
      header: 'Total',
      accessor: 'total',
      dataType: 'currency',
      readOnly: true,
      options: {
        getValue:({row})=>{
          return (row.campaignComponent?.qty??0)*(row.campaignComponent?.unit_value_local??0);
        },
        currency: {
          accessor: 'campaignComponent.currency'
        }
        // eslint-disable-next-line react/prop-types, react/display-name
//      renderEditor: ({ field,row }) => {
        //      return field.currency + asMoney(row.campaignComponent?.qty * row.campaignComponent?.unit_value_local);
        //},
      },
      summaries: {
        footer: ({ rows,currency }) => {
          const defaultCurrency = currency?.id;
          let seenOther = false;
          const value = rows.reduce((total, current) => {
            const cid = current.campaignComponent?.currency?.id;
            if(cid && defaultCurrency != cid) {
              seenOther = true;
            }
            return (total + (parseInt(current.campaignComponent?.qty) * parseInt(current.campaignComponent?.unit_value_local)));
          }, 0)
          if(seenOther) return null;
          return variableCurrencyValue({ currency: currency, value: value, places:2 });
//        return currency + asMoney(rows.reduce((total, current) => { return (total + (parseInt(current.campaignComponent?.qty) * parseInt(current.campaignComponent?.unit_value_local))); }, 0));
        }
      }
    },{
      header: 'Total Quote',
      accessor: 'total_quote',
      dataType: 'currency',
      readOnly: true,
      hideWhen:({exchangeRateContext})=>{
        if(exchangeRateContext.options && exchangeRateContext.options.length>1) return false;
        return true;
      },
      options:{
        getValue: ({ row, calcExchangeRate }) => {
          if(!row.campaignComponent) return '';

          const value= calcExchangeRate(
              row.campaignComponent.currency,
              row.campaignComponent?.unit_value_local,
              row.campaignComponent?.qty
          );
          console.log('EPR currency is',row.campaignComponent?.currency,row.campaignComponent?.unit_value_local,row.campaignComponent?.qty,value);
          return value;
        }
      },
      summaries: {
        footer: ({ rows, currency, calcExchangeRate }) => {
          const value = rows.reduce((total, current) => { return (total + calcExchangeRate(current.campaignComponent.currency,(parseInt(current.campaignComponent?.qty) * parseInt(current.campaignComponent?.unit_value_local)))); }, 0)
          /*
                  const value = rows.reduce((total, current) => {
                    return (total +
                      calcExchangeRate(
                        current.campaignComponent.currency,
                        current.campaignComponent?.unit_value_local,
                        current.campaignComponent?.qty
                        )
                    )});
                    console.log('valueX is',value,total);*/
          return variableCurrencyValue({ currency: currency, value: value, places:2 });
        }
      }
    },

    {
      header: 'Notes',
      accessor: 'name',
      width:'full',
      dataType:'text',
      // eslint-disable-next-line react/display-name,react/prop-types
//    editor: ({ field }) => (<InputGroup {...field} autoFocus={true} />)
    }
  ];

  useEffect(()=>{
    setTab('experientials');
  },[]);
  const allowAddDelete = !(readOnly || isReadOnly(true));

  return <FieldTable name="experientials" columns={columns} newRow={newRow} newRowLabel={allowAddDelete?"Add Experiential":undefined}
    loading={loading} isScrollable={true}
                     hasDelete={allowAddDelete}
    className="campaigns__experientials"
    setValue={setValue} values={values?.experientials} errors={errors} summaries={summaries} readOnly={readOnly} />;
}

export default ExperientialPane;
